import React from "react";
import ChannelBannerViewer from "../../BannerSwap/BannerSwapComponents/ChannelBannersViewer";
import { BannerDashboardTabLayout } from "../bannerDashboardLayout";

/** Default banner table with v2 storage-path column and v2 swap form in dialogs. */
const DefaultBannersTab: React.FC = () => {
  return (
    <BannerDashboardTabLayout>
      <ChannelBannerViewer />
    </BannerDashboardTabLayout>
  );
};

export default DefaultBannersTab;
